import { Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Api from '../../Apis/api.service'
import {
  ButtonViewAllInterventions,
  AlertInfos,
  PrestaInformationsEditForm,
  TicketInformations,
  ViewWrapperDocs,
  FormStep,
} from './partials'

const ExtranetTickets = () => {
  const [record, setRecord] = useState({})
  const [refresh, setRefresh] = useState(new Date().getTime())
  const { id } = useParams()

  const getDetailExtTicket = async (token) => {
    const res = await Api.tickets.getDetailExtTicket(token)
    if (res.status == 200) {
      setRecord(() => {
        return res.data
      })
    } else {
      console.log({ res })
    }
  }
  useEffect(() => {
    if (id) {
      getDetailExtTicket(id)
    }
  }, [refresh])
  return (
    <Grid alignItems="center">
      <ButtonViewAllInterventions
        record={record}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <AlertInfos record={record} refresh={refresh} setRefresh={setRefresh} />
      <TicketInformations
        record={record}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <ViewWrapperDocs
        record={record}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      {record?.is_presta === true &&
      record?.state_transition?.input_columns.find(
        (item) => item.type == 'Facture'
      ) ? (
        <PrestaInformationsEditForm
          record={record}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      <FormStep record={record} refresh={refresh} setRefresh={setRefresh} />
    </Grid>
  )
}
export default ExtranetTickets
